/**
 * Whether a scroller is at its tail (spec 097 FR-012).
 *
 * "At" allows a little slack: a reader who has scrolled to within one entry's
 * height of the bottom is following, and an arrival should carry them down
 * rather than leave them one entry short. The caller supplies that height;
 * `TAIL_FALLBACK_PX` stands in when nothing has been rendered yet.
 */
export interface ScrollMetrics {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
}

export const TAIL_FALLBACK_PX = 64;

export function isAtTail(metrics: ScrollMetrics, threshold: number): boolean {
  const remaining =
    metrics.scrollHeight - (metrics.scrollTop + metrics.clientHeight);
  return remaining <= threshold;
}
